'use client';

import { PWAInstallPrompt } from '@/app/components/shared/PWAInstallPrompt';
import { showUpgradeToast } from '@/app/components/shared/UpgradeToast';
import { isEnterpriseDistribution } from '@/app/constants';
import { useLowCreditsAlert } from '@/app/hooks';
import { usePathname } from '@/i18n/routing';
import { TabForm } from './_components/TabForm';
import { UserQuotaSync } from './_components/UserQuotaSync';

/** Standalone create-tool routes that skip the shared TabForm chrome; add new tools here. */
const STANDALONE_CREATE_TOOL_PATH_PREFIXES = [
  '/create/ai-sound-effects',
  '/create/ai-video-cutter',
  '/create/character-generator',
  '/create/voice-clone',
  '/create/tools',
] as const;

/** 工具聚合入口页（ToolsHub），仅作导航展示、不产生创作动作，跳过低积分订阅弹窗 */
const TOOLS_HUB_PATH = '/create/tools';

export default function Layout({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  useLowCreditsAlert(showUpgradeToast, pathname !== TOOLS_HUB_PATH);
  const isStandaloneToolPage = STANDALONE_CREATE_TOOL_PATH_PREFIXES.some((prefix) => pathname.includes(prefix));
  return (
    <div className="flex h-full flex-col gap-5 sm:gap-3">
      {!isEnterpriseDistribution && <PWAInstallPrompt />}
      <UserQuotaSync />
      {isStandaloneToolPage ? children : <TabForm className="flex-1 overflow-hidden sm:flex-none">{children}</TabForm>}
    </div>
  );
}
